export const environment = {
  api: 'api.dev.roadrunner.cinedeck.app',
  ssl: true,
  theme: 'roadrunner'
};
